/* unplugin-vue-components disabled */import { render } from "./FeedingData.vue?vue&type=template&id=a223d7bc&scoped=true&ts=true"
import script from "./FeedingData.vue?vue&type=script&lang=ts"
export * from "./FeedingData.vue?vue&type=script&lang=ts"

import "./FeedingData.vue?vue&type=style&index=0&id=a223d7bc&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a223d7bc"]])

export default __exports__